export default {
    DATA_LANGUAGE: 'data-language',
    DATA_REFRESH_TOKEN_URL: 'data-refresh-token-url',
    DATA_USER_TOKEN: 'data-user-token',
    LANG: 'lang',
    USERNAME: 'username',
    SCREEN: 'screen',
    FWU_TARGET: 'target',
    FWU_VERSION: 'version',
    IS_SBL: 'isSblFirmware',
    IS_ADVANCED_DIAGNOSTIC: 'isAdvancedDiagnostic',
    RETRY_NUMBER: 'retry',
    NAVIGATION_TARGET: 'target',
    DEVICE_TYPE: 'type',
};
